import { render, staticRenderFns } from "./supplierLogin.vue?vue&type=template&id=2b19010a&scoped=true"
import script from "./supplierLogin.vue?vue&type=script&lang=js"
export * from "./supplierLogin.vue?vue&type=script&lang=js"
import style0 from "./supplierLogin.vue?vue&type=style&index=0&id=2b19010a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b19010a",
  null
  
)

export default component.exports